// Stato scorta (calcolato dal database in gru_v_articoli.stato_scorta) -> colori come in CCO.

const STATI = {
  esaurito: {
    label: 'Esaurito',
    colore: 'text-red-500 font-black',
    punto: 'bg-red-500 shadow-[0_0_8px_rgba(239,68,68,.6)]',
    badge: 'bg-red-500/10 border-red-500/30 text-red-500',
    barra: 'bg-red-500',
    tono: 'error',
  },
  sotto_scorta: {
    label: 'Sotto scorta',
    colore: 'text-amber-500 font-black',
    punto: 'bg-amber-500',
    badge: 'bg-amber-500/10 border-amber-500/30 text-amber-500',
    barra: 'bg-amber-500',
    tono: 'warn',
  },
  ok: {
    label: 'Disponibile',
    colore: 'text-emerald-500 font-bold',
    punto: 'bg-emerald-500',
    badge: 'bg-emerald-500/10 border-emerald-500/30 text-emerald-500',
    barra: 'bg-emerald-500',
    tono: 'ok',
  },
};

export const configScorta = (stato) => STATI[stato] ?? STATI.ok;

/** Quantità con separatori italiani e al massimo `decimali` cifre decimali. */
export const formattaQta = (qta, decimali = 0) => Number(qta ?? 0).toLocaleString('it-IT', {
  minimumFractionDigits: 0,
  maximumFractionDigits: Math.max(0, decimali),
});

/** Percentuale "salute magazzino": giacenza rispetto al doppio della scorta minima (come in CCO). */
export const percentualeScorta = (qta, min) => {
  const q = Number(qta ?? 0);
  const m = Number(min ?? 0);
  if (m > 0) return Math.min(100, Math.round((q / (m * 2)) * 100));
  return q > 0 ? 100 : 0;
};

export const formattaDataOra = (iso) => {
  if (!iso) return '---';
  try {
    return new Date(iso).toLocaleString('it-IT', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return iso;
  }
};

export const formattaData = (iso) => {
  if (!iso) return '---';
  try {
    return new Date(iso).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch {
    return iso;
  }
};

export const ETICHETTE_MOVIMENTO = {
  sostituzione: { label: 'Sostituzione', tono: 'error' },
  rientrato: { label: 'Rientrato', tono: 'ok' },
  carico: { label: 'Carico', tono: 'ok' },
  rettifica: { label: 'Rettifica', tono: 'info' },
  storno: { label: 'Storno', tono: 'warn' },
};
